import { McpScope, McpTokenKind } from '@masters-club/types';
import type { McpTokenItem } from './types';

/** Статус токена для отображения. */
export type McpTokenStatus = 'active' | 'expired' | 'revoked';

/** Дата и время в русском формате; null → «—». */
export function formatDateTime(value: string | null): string {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Вычисляет статус токена по датам отзыва и истечения. */
export function getTokenStatus(token: McpTokenItem, now: number = Date.now()): McpTokenStatus {
  if (token.revokedAt) {
    return 'revoked';
  }
  if (new Date(token.expiresAt).getTime() <= now) {
    return 'expired';
  }
  return 'active';
}

/** Подпись типа токена. */
export function tokenKindLabel(token: McpTokenItem): string {
  if (token.kind === McpTokenKind.PERSONAL) {
    return 'Персональный';
  }
  return `OAuth-клиент${token.clientName ? ` (${token.clientName})` : ''}`;
}

/** Подпись scope. */
export function scopeLabel(scope: string): string {
  if (scope === McpScope.READ) {
    return 'Чтение';
  }
  if (scope === McpScope.WRITE) {
    return 'Запись';
  }
  return scope;
}

/** Склонение «день» для срока токена. */
export function ttlLabel(days: number): string {
  const mod10 = days % 10;
  const mod100 = days % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return `${days} день`;
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${days} дня`;
  }
  return `${days} дней`;
}

/** Хост из URL (для показа, куда вернёт OAuth-клиент). */
export function hostOf(url: string): string {
  try {
    return new URL(url).host || url;
  } catch {
    return url;
  }
}
